import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { ContentToolsModule } from '../../../shell/content-tools/content-tools.module';
import { ListSearchModule } from '../list-search/list-search.module';
import { MyStudentsListComponent } from './my-students-list.component';
import { MyStudentsMadLibModule } from './my-students-mad-lib/my-students-mad-lib.module';

@NgModule({
  declarations: [MyStudentsListComponent],
  imports: [CommonModule, MyStudentsMadLibModule, ListSearchModule, MatDividerModule, ContentToolsModule],
  exports: [],
  providers: [MyStudentsListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class MyStudentsListModule {
  /** */
}
